import React from 'react'
import Link from 'gatsby-link'

const ArchiveContent = ({ data, archiveType }) => (
    <div>
        {
            data.featured_media != 'false' &&
            <Link to={`/${archiveType}/${data.slug}`}>
            <div className="featured-image">
                <img src={ data.featured_media } />
            </div>
            </Link>
        }
        {
            data.featured_media == 'false' &&
            <div className="featured-image" />
        }
        <Link to={ `/${archiveType}/${data.slug}`}><h2 className="h2" dangerouslySetInnerHTML={{ __html: data.title }} /></Link>
        <p dangerouslySetInnerHTML={{ __html: data.excerpt }} />
        <p className="date">{ data.date }</p>
        <Link style={{ marginTop:'10px', display:'inline-block', cursor:'pointer' }} className="hoverlink" to={ `/${archiveType}/${data.slug}`}>Read More</Link>
    </div>
)


export default ArchiveContent



// WEBPACK FOOTER //
// ./src/components/ArchiveContent/index.js